var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M80 16H16C11.5817 16 8 19.5817 8 24V72C8 76.4183 11.5817 80 16 80H80C84.4183 80 88 76.4183 88 72V24C88 19.5817 84.4183 16 80 16Z","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M88 28L52.12 50.8C50.8851 51.5737 49.4573 51.984 48 51.984C46.5427 51.984 45.1149 51.5737 43.88 50.8L8 28","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Mail.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
